import service from '@/utils/server';

const modName='/order/salesApprove/';
const downloadFileModeName = '/common/web/download/';

//查询方法
export const pageInfo = data => {
  console.log('pageInfo', '-----');
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};
//初始化页面对象
export const initPage = data => {
  return service({
    url: modName + 'initPage',
    method: 'post',
    data
  });
};

//新增方法
export const saveData = data => {
  return service({
    url: modName + 'add',
    method: 'post',
    data
  });
};
//初始化更新对象
export const initUpdate = data => {
  return service({
    url: modName + 'initUpdate/' + data,
    method: 'post',
    data
  });
};
//修改方法
export const editData = data => {
  return service({
    url: modName + 'update',
    method: 'post',
    data
  });
};
//删除方法
export const deleteData = data => {
  return service({
    url: modName + 'delete/'+data.id,
    method: 'post',
    data
  });
};


//导出excel
export const exportData = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'export',
    method: 'post',
    data
  });
};

//基本信息
export const orderBasicDetailsInfo = data => {
  return service({
    url: modName + 'orderBasicDetailsInfo',
    method: 'post',
    data
  })
};

// 初始化订单数据
export const initOrderApprovedData = data => {
  return service({
    url: modName + 'initOrderApprovedData',
    method: 'post',
    data
  });
};

//文件下载
export const fileDownload = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: downloadFileModeName + 'file/'+data,
    method: 'post',
    data
  });
};

// 同意
export const approveAgree = data => {
  return service({
    url: modName + 'approveAgree',
    method: 'post',
    data
  });
};

// 批量同意
export const batchApproveAgree = data => {
  return service({
    url: modName + 'batchApproveAgree',
    method: 'post',
    data
  });
};

//拒绝
export const refuseApproved = data => {
  return service({
    url: modName + 'approveRefuse',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/order/salesApprove/api/index.js